import {ExportTicketStatusEntity} from "@dropDesk/domain/entities/ticket/export_ticket_status.entity";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";

export class ChatOperationsEntity {
    errorSelectSector?: number;
    errorSelectRating?: number;
    waitingConfirmClose?: boolean;
    closedByClient?: boolean;
    reference?: string;
    serverReference?: string;
    clientReference?: string;
    evaluate?: { canEvaluate?: boolean, evaluated?: boolean }
    idTicketReference?: string;
    exportStatus?:Record<UserRole, ExportTicketStatusEntity>;



    static fromJson(json: Record<string, any>): ChatOperationsEntity {
        return new ChatOperationsEntity({
            errorSelectSector: json['errorSelectSector'] as number | undefined,
            errorSelectRating: json['errorSelectRating'] as number | undefined,
            waitingConfirmClose: json['waitingConfirmClose'] as boolean | undefined,
            closedByClient: json['closedByClient'] as boolean | undefined,
            reference: json['reference'] as string | undefined,
            serverReference: json['serverReference'] as string | undefined,
            clientReference: json['clientReference'] as string | undefined,
            evaluate: json['evaluate'] as { canEvaluate?: boolean, evaluated?: boolean } | undefined,
            idTicketReference: json['idTicketReference'] as string | undefined,
            exportStatus: json['exportStatus']
                ? (Object.fromEntries(
                    Object.entries(json['exportStatus'] as Partial<Record<UserRole, any>>)
                        .filter(([, v]) => v != null)
                        .map(([role, data]) => [
                            role,
                            ExportTicketStatusEntity.fromJson((data as any).exportStatus ?? data),
                        ])
                ) as Partial<Record<UserRole, ExportTicketStatusEntity>>)
                : undefined,
        });
    }

    constructor({
                    errorSelectSector,
                    errorSelectRating,
                    waitingConfirmClose,
                    closedByClient,
                    reference,
                    serverReference,
                    clientReference,
                    evaluate,
                    idTicketReference,
                    exportStatus,
                }: {
        errorSelectSector?: number;
        errorSelectRating?: number;
        waitingConfirmClose?: boolean;
        closedByClient?: boolean;
        reference?: string;
        serverReference?: string;
        clientReference?: string;
        evaluate?: { canEvaluate?: boolean, evaluated?: boolean }
        idTicketReference?: string;
        exportStatus?: Partial<Record<UserRole, ExportTicketStatusEntity>>;
    }) {
        Object.assign(this, {
            errorSelectSector,
            errorSelectRating,
            waitingConfirmClose,
            closedByClient,
            reference,
            serverReference,
            clientReference,
            evaluate,
            idTicketReference,
            exportStatus,
        });
    }

    copyWith({
                 errorSelectSector,
                 errorSelectRating,
                 waitingConfirmClose,
                 closedByClient,
                 reference,
                 serverReference,
                 clientReference,
                 evaluate,
                 idTicketReference,
                 exportStatus,
             }: {
        errorSelectSector?: number;
        errorSelectRating?: number;
        waitingConfirmClose?: boolean;
        closedByClient?: boolean;
        reference?: string;
        serverReference?: string;
        clientReference?: string;
        evaluate?: { canEvaluate?: boolean, evaluated?: boolean }
        idTicketReference?: string;
        exportStatus?: Partial<Record<UserRole, ExportTicketStatusEntity>>;

    }): ChatOperationsEntity {
        return new ChatOperationsEntity({
            errorSelectSector: errorSelectSector ?? this.errorSelectSector,
            errorSelectRating: errorSelectRating ?? this.errorSelectRating,
            waitingConfirmClose: waitingConfirmClose ?? this.waitingConfirmClose,
            closedByClient: closedByClient ?? this.closedByClient,
            reference: reference ?? this.reference,
            serverReference: serverReference ?? this.serverReference,
            clientReference: clientReference ?? this.clientReference,
            evaluate: evaluate ?? this.evaluate,
            idTicketReference: idTicketReference ?? this.idTicketReference,
            exportStatus: exportStatus ?? this.exportStatus,
        })
    }
}
